:host,
app-root {
  display: contents;
}

.page-header .links {
  margin-top: -3.5em;
  margin-bottom: -.25em;
  padding-top: 0;
  padding-bottom: var(--unit);
}

.page-header .links a {
  display: flex;
}

.page-header .links img {
  height: 24px;
}

.page-body {
  padding-bottom: 5em;
}